import { Typography } from '@mui/material';
import dayjs from 'dayjs';
import { memo } from 'react';
import { If, Then } from 'react-if';

interface MultiStoreDayTitleProps {
  day?: string;
}

// Titolo del giorno scelto, come nel DatePicker classico
export const MultiStoreDayTitle = memo(function MultiStoreDayTitle({
  day,
}: MultiStoreDayTitleProps): JSX.Element {
  return (
    <If condition={day !== undefined}>
      <Then>
        <div className="multi-store-day-title">
          <Typography variant="contentDescription1">
            {dayjs(day, 'YYYY-MM-DD').locale('it').format('dddd DD MMMM YYYY')}
          </Typography>
        </div>
      </Then>
    </If>
  );
});
